import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the scroll position on every navigation to a new url, also when the
 * page itself is not remounted. Navigations targeting an anchor (#hash) are
 * left alone so the page can scroll to the element instead.
 */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
